import React from 'react';
import { withStyles, Theme, createStyles, Tab, Tabs } from '@material-ui/core';

export const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#1890ff',
    },
  })(Tabs);
  
export const AntTab = withStyles((theme: Theme) =>
    createStyles({
      root: {
        textTransform: 'none',
        minWidth: 30,
        fontFamily: [
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          'sans-serif',
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
          color: '#186ea8',
          opacity: 1,
        },
        '&$selected': {
          //color: '#1890ff',
        },
        '&:focus': {
          // color: '#40a9ff',
        },
      },
      selected: {},
    }),
  )((props: StyledTabProps) => <Tab className={props.className} disableRipple {...props} />);
  
  interface StyledTabProps {
    label: string;
    className?: string
  }
  
  